import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import { DataSource, Repository } from "typeorm"
import { DepartmentEntity } from "./department.entity"
import { CommonResponseModel } from "@project-management-system/shared-models"
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object"
import { DepartmentDto } from "./departments.dto"
import { PlantsEntity } from "../plants/plants.entity"


@Injectable()
export class DepartmentService {
    constructor(
        @InjectRepository(DepartmentEntity)

        private repo: Repository<DepartmentEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createDepartment(req: DepartmentDto): Promise<CommonResponseModel> {

        try {

            const Check = await this.repo.find({ where: { departmentName: req.departmentName } })
            if (Check.length > 0) {
                return new CommonResponseModel(false, 0, 'Department Name already exists')
            }
            const entity = new DepartmentEntity()
            entity.departmentName = req.departmentName;
            entity.hod = req.hod;
            entity.hodId = req.hodId;
            let plant = new PlantsEntity()
            plant.plantId = req.plantId;
            entity.plantsInfo = plant
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;
            if (req.id) {
                entity.updatedUser = req.createdUser
            } else {
                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in Department creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllDepartments(): Promise<CommonResponseModel> {
        const query =
            `SELECT p.plant_id AS plantId, p.plant_name AS plantName, d.department_name AS departmentName,d.hod AS hod, d.id, d.hod_id AS HOD, d.is_active AS isActive, count(ep.id) AS employeeCount,d.hod_id as hodId
        FROM department d 
        LEFT JOIN  plants p ON p.plant_id = d.plant_id
        LEFT JOIN  employee e ON e.id = d.hod_id
        LEFT JOIN  employee ep ON ep.department_name = d.id 
        GROUP BY d.id 
        order by p.plant_name, d.department_name, d.hod ASC;
    `
        const data = await this.dataSource.query(query);

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    } catch(err) {
        return err;
    }

    async getActiveAllDepartments(): Promise<CommonResponseModel> {
        const data = await this.repo.find({
            where: {
                isActive: true
            }
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async updateDepartment(req: DepartmentDto): Promise<CommonResponseModel> {

        try {
            const Check = await this.repo.find({ where: { departmentName: req.departmentName } })
            if (Check.length > 0) {
                return new CommonResponseModel(false, 0, 'Department Name already exists')
            }
            let Product;
            Product = await this.repo.update(
                { id: req.id },
                {
                    departmentName: req.departmentName,
                    hod: req.hod,
                    hodId: req.hodId,
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateDepartment(req: DepartmentDto): Promise<CommonResponseModel> {
        try {
            // console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Department information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Department is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Department is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Department is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Department is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }




}